/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationBatchChangeStatusRequestViewModel } from "../types/CourseRegistrationBatchChangeStatusRequestViewModel.ts";
import { eEnrollmentStatusSchema } from "./eEnrollmentStatusSchema.ts";

export const courseRegistrationBatchChangeStatusRequestViewModelSchema =
  z.object({
    courseRegistrationsId: z
      .array(z.number().int())
      .describe("Lista de IDs das matrículas a terem o status alterado.")
      .nullish(),
    classStudentId: z.optional(
      z.number().int().describe("ID da turma à qual as matrículas pertencem."),
    ),
    enrollmentStatus: z.optional(
      z
        .lazy(() => eEnrollmentStatusSchema)
        .describe(
          "1 = PaymentSelection | 2 = PaymentPending | 3 = ApprovalPending | 4 = Approved | 5 = Activating | 6 = Active | 7 = Transferred | 8 = TransferredInRegistration | 9 = Canceled | 10 = CanceledInRegistration | 11 = Rejected | 12 = FinishedWithPendencies | 13 = Finished | 14 = FinishedWithMonograph | 15 = FinishedWithCertificate | 16 = Blocked | ",
        ),
    ),
    sendNotification: z.optional(
      z
        .boolean()
        .describe(
          "Define se uma notificação deve ser enviada ao aluno após a alteração de status.",
        ),
    ),
    observation: z
      .string()
      .describe(
        "Observação registrada junto à alteração de status. Obrigatória para status de cancelamento. Opcional nos demais casos.",
      )
      .nullish(),
    statusReasonId: z
      .number()
      .int()
      .describe(
        "ID do motivo do status. Obrigatório para status de cancelamento. Opcional nos demais casos.",
      )
      .nullish(),
    subStatusReasonId: z
      .number()
      .int()
      .describe(
        "ID do submotivo do status. Obrigatório para status de cancelamento. Opcional nos demais casos.",
      )
      .nullish(),
    sendCertificateByEmail: z.optional(
      z
        .boolean()
        .describe(
          "Define se o certificado de conclusão deve ser enviado por e-mail ao aluno. Aplicável apenas quando o status destino for FinishedWithCertificate.",
        ),
    ),
  }) as unknown as ToZod<CourseRegistrationBatchChangeStatusRequestViewModel>;
